// src/pages/LCP.js 
// (Assuming this file contains your LCP component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import LCPcontent from './PageComponent/LCPcontent'


function LCP() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Light Control & Privacy | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Looking for light control and privacy? Discover stylish solutions that transform your space. Click to explore our top picks!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/light-control-privacy/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Light Control & Privacy" />
                <meta
                    property="og:description"
                    content="Looking for light control and privacy? Discover stylish solutions that transform your space. Click to explore our top picks!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/light-control-privacy/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <LCPcontent />
                <Footer />
            </div>
        </>
    );
}

export default LCP;